module.exports = __webpack_public_path__ + "static/gradientOne-c3f9b2dd9e35875ce1f1f7a5ab6f4133.png";